import { supabase } from '@/supabase/client';

type ProspectError = Error & { code?: string };

function createError(code: string, message = code): ProspectError {
  const error: ProspectError = new Error(message);
  error.code = code;
  return error;
}

type ProspectProfile = {
  user_id: string;
  [key: string]: unknown;
};

export async function loadProspect(handle?: string | null): Promise<ProspectProfile> {
  if (!handle) {
    throw createError('missing_handle', 'Prospect handle is required');
  }

  const {
    data: { user },
    error: userError,
  } = await supabase.auth.getUser();

  if (userError) {
    throw userError;
  }

  if (!user) {
    throw createError('not_authenticated', 'User not authenticated');
  }

  const { data, error } = await supabase
    .from('prospect_profiles')
    .select('*')
    .eq('handle', handle as string)
    .single();

  if (error) {
    throw error;
  }

  if (!data) {
    throw createError('not_found', 'Prospect not found');
  }

  const profile = data as unknown as ProspectProfile;

  if (profile.user_id !== user.id) {
    throw createError('forbidden', 'You do not have access to this prospect');
  }

  return profile;
}
